/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { createRegressionModel, trainPretrainedModel } from './whatIfCore'
import {
	whatIfModelToJson, buildWhatIfModelFromJson
} from './utils/ModelSerialization'


define([], function () {
	'use strict'

	class WhatIfService {
		createModel(config) {
			return createRegressionModel(config).then((model) => {
				return model
			})
		}
		continueTraining(regressionModel, data, epochs) {
			return trainPretrainedModel(regressionModel, data, epochs).then((model) => {
				return model
			})
		}

		serializeWhatIfModel(model) {
			return whatIfModelToJson(model);
		}

		buildWhatIfModelFromJson(json) {
			return buildWhatIfModelFromJson(json);
		}

	}

	return WhatIfService
})